import { render, staticRenderFns } from "./CTTReward.vue?vue&type=template&id=1e54d5fc"
import script from "./CTTReward.vue?vue&type=script&lang=js"
export * from "./CTTReward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports